import axios from 'axios';
import { PackagedGoodsControl } from '../../types/PackagedGoodsControl';
import { PaginatedResult, PaginationParams, TableFilterData } from '../../types/general-types';

class PackagedGoodsControlsService {
  async getAll(): Promise<PackagedGoodsControl[]> {
    const result = await axios.get('/packaged-goods-controls');
    return result.data.map(mapFromApiResponse);
  }

  async get(id: string): Promise<PackagedGoodsControl> {
    const result = await axios.get(`/packaged-goods-controls/${id}`);
    return result.data && mapFromApiResponse(result.data);
  }

  async search(
    filters: TableFilterData,
    paginationParams: PaginationParams
  ): Promise<PaginatedResult<PackagedGoodsControl>> {
    const result = await axios.post(`/packaged-goods-controls/search`, { filters, paginationParams });
    return {
      data: result.data.data.map(mapFromApiResponse),
      totalCount: result.data.totalCount,
    };
  }

  async delete(id: string): Promise<void> {
    return axios.delete(`/packaged-goods-controls/${id}`);
  }

  async create(postData: PackagedGoodsControl): Promise<void> {
    return axios.post(`/packaged-goods-controls`, mapToRequestBody(postData));
  }

  async edit(postData: PackagedGoodsControl, id: string): Promise<void> {
    return axios.put(`/packaged-goods-controls/${id}`, mapToRequestBody(postData));
  }

  async start(id: string): Promise<void> {
    return axios.post(`/packaged-goods-controls/${id}/start`);
  }
  async pause(id: string): Promise<void> {
    return axios.post(`/packaged-goods-controls/${id}/pause`);
  }
  async resume(id: string): Promise<void> {
    return axios.post(`/packaged-goods-controls/${id}/resume`);
  }
  async finish(id: string): Promise<void> {
    return axios.post(`/packaged-goods-controls/${id}/finish`);
  }
  async cancel(id: string): Promise<void> {
    return axios.post(`/packaged-goods-controls/${id}/cancel`);
  }

  async getReport(id: string, fileFormat: string) {
    let dataToSend: any = {
      fileFormat,
    };

    return axios.post(`/packaged-goods-controls/${id}/report`, dataToSend, {
      responseType: 'arraybuffer',
    });
  }
}

const mapFromApiResponse = (packagedGoodsControl: any): PackagedGoodsControl => {
  return {
    ...packagedGoodsControl,

    plannedDate: packagedGoodsControl.plannedDate && new Date(packagedGoodsControl.plannedDate),

    startDate: packagedGoodsControl.startDate && new Date(packagedGoodsControl.startDate),

    endDate: packagedGoodsControl.endDate && new Date(packagedGoodsControl.endDate),
  };
};

const mapToRequestBody = (packagedGoodsControl: PackagedGoodsControl): any => {
  const result = {
    id: packagedGoodsControl.id,
    name: packagedGoodsControl.name,
    controlType: packagedGoodsControl.controlType,
    productId: packagedGoodsControl.productId,
    densityGMl: packagedGoodsControl.densityGMl,
    tareWeightG: packagedGoodsControl.tareWeightG,
    lotNumber: packagedGoodsControl.lotNumber,
    plannedDate: packagedGoodsControl.plannedDate,
    startDate: packagedGoodsControl.startDate,
    endDate: packagedGoodsControl.endDate,
    lotQuantity: packagedGoodsControl.lotQuantity,
    status: packagedGoodsControl.status,
    result: packagedGoodsControl.result,
    t1Error: packagedGoodsControl.t1Error,
    controlPhase1Quantity: packagedGoodsControl.controlPhase1Quantity,
    controlTotalQuantity: packagedGoodsControl.controlTotalQuantity,
    scaleIds: packagedGoodsControl.scaleIds,
  };

  return result;
};

const packagedGoodsControlsService = new PackagedGoodsControlsService();
export default packagedGoodsControlsService;
